<template>
  <v-container
    fluid
    :class="{
      'grid-list-lg fluid': modalMode,
      'px-0': !packageMode,
      'py-0': !packageMode,
      block: packageMode,
      isBlocked: !editMode,
    }"
  >
    <loading v-if="!companyData" />

    <v-layout row wrap v-else>
      <v-flex xs12>
        <v-form ref="form" v-model="valid" lazy-validation  >
          <v-layout row wrap v-if="!packageMode && !companyData.inn">
            <v-flex>
              <v-text-field
                v-model="innOgrn"
                :placeholder="$t('components.clients.company.innOgrn.placeholder')"
                :hint="$t('components.clients.company.innOgrn.hint')"
                @keyup.enter="getCompanyByInnOgrn"
                persistent-hint
                outlined
              ></v-text-field>
            </v-flex>
            <v-flex>
              <v-btn
                @click="getCompanyByInnOgrn"
                :loading="isGetCompanyByInnOgrn"
                :disabled="!innOgrn"
                color="primary"
                outlined
                >{{$t('components.clients.company.innOgrn.submit')}}</v-btn
              >
            </v-flex>
            <v-flex xs12>
              <h3 class="error--text">{{ getCompanyByInnOgrnMessage }}</h3>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs12>
              <h3>{{$t('components.clients.company.hGenInformation')}}</h3>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6 sm6 md6>
              <v-text-field
                v-model="companyData.organization_full_name"
                :label="$t('components.clients.company.organizationFullName')"
                :rules="rules.organization_full_name"
                :disabled="!editMode"
                outlined
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm6 md6>
              <v-text-field
                v-model="companyData.organization_short_name"
                :label="$t('components.clients.company.organizationShortName')"
                :rules="rules.organization_short_name"
                :disabled="!editMode"
                outlined
                required
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs4 sm4 md4>
              <v-text-field
                v-model="companyData.inn"
                :label="$t('components.clients.company.inn')"
                :rules="rules.rule"
                :error-messages="errorMessages.inn"
                :disabled="!editMode"
                required
                outlined
                v-if="companyData.organization_type != 1"
              ></v-text-field>
              <v-text-field
                v-model="companyData.inn"
                :label="$t('components.clients.company.inn')"
                :rules="rules.rule"
                :error-messages="errorMessages.inn"
                :disabled="!editMode"
                required
                outlined
                v-else
              ></v-text-field>
            </v-flex>
            <v-flex xs4 sm4 md4>
              <v-text-field
                v-model="companyData.ogrn"
                :label="$t('components.clients.company.ogrn')"
                :rules="rules.rule"
                :error-messages="errorMessages.ogrn"
                :disabled="!editMode"
                required
                outlined
                v-if="companyData.organization_type != 1"
              ></v-text-field>
              <v-text-field
                v-model="companyData.ogrn"
                :label="$t('components.clients.company.ogrn')"
                :rules="rules.rule"
                :error-messages="errorMessages.ogrn"
                :disabled="!editMode"
                required
                outlined
                v-else
              ></v-text-field>
            </v-flex>
            <v-flex xs4 sm4 md4>
              <v-text-field
                v-model="companyData.kpp"
                :label="$t('components.clients.company.kpp')"
                v-if="companyData.organization_type != 1"
                :rules="rules.rule"
                :disabled="!editMode"
                required
                outlined
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs4 sm4 md4>
              <v-text-field
                v-model="companyData.okpo"
                :label="$t('components.clients.company.okpo')"
                :error-messages="errorMessages.okpo"
                :disabled="!editMode"
                outlined
                v-if="companyData.organization_type == 1"
              ></v-text-field>
              <v-text-field
                v-model="companyData.okpo"
                :label="$t('components.clients.company.okpo')"
                :disabled="!editMode"
                outlined
                v-else
              ></v-text-field>
            </v-flex>
            <v-flex xs4 sm4 md4>
              <v-layout row wrap>
                <v-flex grow>
                  <v-text-field
                    v-model="companyData.okved"
                    :label="$t('components.clients.company.okved')"
                    :rules="rules.okved"
                    :disabled="!editMode"
                    required
                    outlined
                  ></v-text-field>

                  <!-- <v-combobox
                                        :items="okveds"
                                        v-model="okved"
                                        label=""
                                        :rules="rules.okved"
                                        validate-on-blur
                                        required
                                    ></v-combobox>-->

                  <!-- <v-combobox
                                        v-model="companyData.okved"
                                        :items="okveds"
                                        item-text="name"
                                        item-value="kod"
                                        :search-input.sync="search"
                                        :hide-no-data="!search"
                                        label="ОКВЭД"
                                        @input.native="getOkveds"
                                        persistent-hint
                                    >
                                        <template v-slot:no-data>
                                            <v-list-tile>
                                                <v-list-tile-content>
                                                    <v-list-tile-title>
                                                        <strong>{{ search ? `"${search}""` : `Введите номер` }}</strong>. Нажмите
                                                        <kbd>enter</kbd> для вариантов
                                                    </v-list-tile-title>
                                                </v-list-tile-content>
                                            </v-list-tile>
                                        </template>
                                    </v-combobox>-->
                </v-flex>
                <v-flex shrink>
                  <tips tipId="okved" />
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs4 sm4 md4 v-if="!isCompanyIndividual">
              <v-autocomplete
                v-model="companyData.organization_type"
                :items="legalTypes"
                item-text="name"
                item-value="value"
                :rules="rules.organization_type"
                :label="$t('components.clients.company.organizationType')"
                :disabled="!editMode"
                required
                outlined
              ></v-autocomplete>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs6 sm6 md6>
              <v-text-field
                v-model="companyData.contact_person_full_name"
                :label="$t('components.clients.company.contactPersonFullName')"
                :rules="rules.contact_person_full_name"
                :disabled="!editMode"
                required
                outlined
              ></v-text-field>
            </v-flex>

            <v-flex xs6 sm6 md6>
              <v-text-field
                v-model="companyData.contact_person_phone"
                :label="$t('components.clients.company.contactPersonPhone')"
                v-mask="'(###) ###-##-##'"
                prefix="+7 "
                :rules="rules.contact_person_phone"
                :disabled="!editMode"
                required
                outlined
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs6 sm6 md6>
              <v-text-field
                v-model="companyData.bidder_site_url"
                :label="$t('components.clients.company.bidderSiteUrl')"
                :disabled="!editMode"
                outlined
              ></v-text-field>
            </v-flex>

            <v-flex xs6 sm6 md6>
              <v-text-field
                v-model="companyData.bidder_email"
                :label="$t('components.clients.company.bidderEmail')"
                :rules="rules.bidder_email"
                :disabled="!editMode"
                required
                outlined
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs12>
              <h3>{{$t('components.clients.company.hLegalAddress')}}</h3>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs8 sm8 md8>
              <v-text-field
                v-model="companyData.legal_city"
                :label="$t('components.clients.company.city')"
                :rules="rules.city"
                :disabled="!editMode"
                required
                outlined
              ></v-text-field>
            </v-flex>
            <v-flex xs14 sm4 md4>
              <v-text-field
                v-model="companyData.legal_zipcode"
                :label="$t('components.clients.company.zipcode')"
                type="number"
                :rules="rules.zipcode"
                :disabled="!editMode"
                required
                outlined
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs8 sm8 md8>
              <v-text-field
                v-model="companyData.legal_street"
                :label="$t('components.clients.company.street')"
                :rules="rules.street"
                :disabled="!editMode"
                required
                outlined
              ></v-text-field>
              <!--
                            <v-combobox
                                :items="streets"
                                v-model="companyData.legal_street"
                                label="Улица"
                                :rules="rules.street"
                                required
                            ></v-combobox>
                            -->
            </v-flex>

            <v-flex xs2 sm2 md2>
              <v-text-field
                v-model="companyData.legal_house"
                :label="$t('components.clients.company.house')"
                :rules="rules.house"
                :disabled="!editMode"
                required
                outlined
              ></v-text-field>
            </v-flex>

            <v-flex xs2 sm2 md2>
              <v-text-field
                v-model="companyData.legal_office"
                :label="$t('components.clients.company.office')"
                :disabled="!editMode"
                outlined
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex shrink>
              <h3>{{$t('components.clients.company.hPostAddress')}}</h3>
            </v-flex>
            <v-flex shrink address-toggle v-if="editMode">
              <v-checkbox
                :label="$t('components.clients.company.postAddressAsLegal')"
                v-model="setPostAddressAsLegal"
                class="mt-0 pt-1"
                color="warning"
                hide-details
                :disabled="!editMode"
                outlined
              ></v-checkbox>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="setPostAddressAsLegal">
            <v-flex xs8 sm8 md8>
              <v-text-field
                v-model="companyData.legal_city"
                :label="$t('components.clients.company.city')"
                :rules="rules.city"
                :disabled="!editMode || setPostAddressAsLegal"
                required
                outlined
              ></v-text-field>
            </v-flex>
            <v-flex xs4 sm4 md4>
              <v-text-field
                v-model="companyData.legal_zipcode"
                :label="$t('components.clients.company.zipcode')"
                type="number"
                :rules="rules.zipcode"
                :disabled="!editMode || setPostAddressAsLegal"
                required
                outlined
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout row wrap v-else>
            <v-flex xs8 sm8 md8>
              <v-text-field
                v-model="companyData.postal_city"
                :label="$t('components.clients.company.city')"
                :rules="rules.city"
                :disabled="!editMode || setPostAddressAsLegal"
                required
                outlined
              ></v-text-field>
            </v-flex>
            <v-flex xs4 sm4 md4>
              <v-text-field
                v-model="companyData.postal_zipcode"
                :label="$t('components.clients.company.zipcode')"
                :rules="rules.zipcode"
                :disabled="!editMode || setPostAddressAsLegal"
                required
                outlined
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout row wrap v-if="setPostAddressAsLegal">
            <v-flex xs8 sm8 md8>
              <v-text-field
                v-model="companyData.legal_street"
                :label="$t('components.clients.company.street')"
                :rules="rules.street"
                :disabled="!editMode || setPostAddressAsLegal"
                required
                outlined
              ></v-text-field>
            </v-flex>

            <v-flex xs2 sm2 md2>
              <v-text-field
                v-model="companyData.legal_house"
                :label="$t('components.clients.company.house')"
                :rules="rules.house"
                :disabled="!editMode || setPostAddressAsLegal"
                required
                outlined
              ></v-text-field>
            </v-flex>

            <v-flex xs2 sm2 md2>
              <v-text-field
                v-model="companyData.legal_office"
                :label="$t('components.clients.company.office')"
                :disabled="!editMode || setPostAddressAsLegal"
                outlined
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout row wrap v-else>
            <v-flex xs8 sm8 md8>
              <v-text-field
                v-model="companyData.postal_street"
                :label="$t('components.clients.company.street')"
                :rules="rules.street"
                :disabled="!editMode || setPostAddressAsLegal"
                required
                outlined
              ></v-text-field>
            </v-flex>

            <v-flex xs2 sm2 md2>
              <v-text-field
                v-model="companyData.postal_house"
                :label="$t('components.clients.company.house')"
                :rules="rules.house"
                :disabled="!editMode || setPostAddressAsLegal"
                required
                outlined
              ></v-text-field>
            </v-flex>

            <v-flex xs2 sm2 md2>
              <v-text-field
                v-model="companyData.postal_office"
                :label="$t('components.clients.company.office')"
                :disabled="!editMode || setPostAddressAsLegal"
                outlined
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs12>
              <h3>{{$t('components.clients.company.hAdditionalInformation')}}</h3>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs6 sm6 md6>
              <v-menu
                ref="organization_created_date"
                v-model="organizationCreatedDate"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="organization_created_date"
                    :label="$t('components.clients.company.organizationCreatedDate')"
                    prepend-icon="event"
                    v-on="on"
                    v-on:blur="formatOrganizationCreatedDate"
                    :rules="rules.organization_created_date"
                    v-mask="'##.##.####'"
                    return-masked-value
                    :disabled="!editMode"
                    required
                    outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                  ref="picker"
                  v-model="companyData.organization_created_date"
                  :max="new Date().toISOString().substr(0, 10)"
                  min="1900-01-01"
                  @change="saveOrganizationCreatedDate"
                  llocale="ru-ru"
                  first-day-of-week="1"
                  no-title
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs6 sm6 md6>
              <v-layout row wrap>
                <v-flex grow>
                  <v-text-field
                    v-model="companyData.reg_certificate_number"
                    :label="$t('components.clients.company.regCertificateNumber')"
                    :disabled="!editMode"
                    outlined
                  ></v-text-field>
                </v-flex>
                <v-flex shrink>
                  <tips tipId="registerId" />
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs12 sm4 md4>
              <v-autocomplete
                :items="taxTypes"
                v-model="companyData.tax_system"
                :label="$t('components.clients.company.taxSystem')"
                item-text="name"
                item-value="value"
                :rules="rules.tax_system"
                :disabled="!editMode"
                required
                outlined
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 sm4 md4>
              <v-autocomplete
                v-model="companyData.legal_form"
                :items="organizationTypes"
                item-text="name"
                item-value="value"
                :label="$t('components.clients.company.legalForm')"
                :rules="rules.legal_form"
                :disabled="!editMode"
                required
                outlined
              ></v-autocomplete>
            </v-flex>

            <v-flex xs12 sm4 md4>
              <v-autocomplete
                :items="purposeTypes"
                v-model="companyData.organization_purpose"
                :label="$t('components.clients.company.organizationPurpose')"
                item-text="name"
                item-value="value"
                :rules="rules.organization_purpose"
                :disabled="!editMode"
                required
                outlined
              ></v-autocomplete>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs12 sm6 md6>
              <v-text-field
                v-model="companyData.reg_organization_name"
                :label="$t('components.clients.company.regOrganizationName')"
                :rules="rules.reg_certificate_name"
                :disabled="!editMode"
                required
                outlined
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                v-model="companyData.reg_place"
                :label="$t('components.clients.company.regPlace')"
                :rules="rules.reg_place"
                :disabled="!editMode"
                required
                outlined
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout form__row form__errors row wrap v-if="errors">
            <v-flex xs12>
              {{$t('components.clients.company.checkErrors')}}:
              <strong v-for="(error, idx) in errors" :key="`error_f${idx}`">{{
                error
              }}</strong>
            </v-flex>
          </v-layout>

          <v-layout form__row form__errors row wrap v-if="errorsText">
            <v-flex xs12>
              {{$t('components.clients.company.checkErrors')}}:
              <strong>{{ errorsText }}</strong>
            </v-flex>
          </v-layout>
          <v-btn
            @click="validate"
            color="primary"
            class="mt-4 ml-0"
            :disabled="isUpdated"
            id="companySaveButton"
            v-if="!packageMode && isPublicHashSave"
            >{{
              isUpdated ? $t('components.clients.company.updatedFormButton') : $t('components.clients.company.saveFormButton')
            }}</v-btn
          >
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { apiCallTrue } from "@/utils/api";
import tips from "@/components/lib/tips";
import rules from "@/utils/data/rules";
import axios from "axios";
import showNotify from "@/services/noty";
import { mask } from "vue-the-mask";
import i18n from "@/services/i18n";

export default {
  name: "MyCompany",
  directives: { mask },
  data: () => ({
    valid: false,
    errors: null,
    errorsText: null,
    errorMessages: {
      okpo: "",
      ogrn: "",
      inn: "",
    },
    isGetCompanyByInnOgrn: false,
    getCompanyByInnOgrnMessage: null,
    isUpdated: false,
    organizationCreatedDate: false,
    organization_created_date: "",
    setPostAddressAsLegal: true,
    innOgrn: "", // 667341171532
    streets: [],
    okved: null,
    okveds: [], // [{ name: "Нет номера", value: "" }],
    search: null,
    legalTypes: [
      { name: i18n.t('legalTypes.1'), value: 1 },
      { divider: true },
      { name: i18n.t('legalTypes.2'), value: 2 },
      { name: i18n.t('legalTypes.3'), value: 3 },
    ],
    taxTypes: [
      { name: i18n.t('taxTypes.1'), value: 1 },
      { name: i18n.t('taxTypes.2'), value: 2 },
    ],
    organizationTypes: [
      { name: i18n.t('organizationTypes.1'), value: 1 },
      { name: i18n.t('organizationTypes.2'), value: 2 },
    ],
    purposeTypes: [
      {
        name: i18n.t('purposeTypes.1'),
        value: 1,
      },
      { name: i18n.t('purposeTypes.2'), value: 2 },
    ],
    rules: rules,
  }),
  props: {
    publicHash: {
      type: String,
      default: "",
    },
    bidStatus: {
      type: Number,
      default: 0
    },
    companyData: {
      type: Object,
    },
    packageMode: {
      type: Boolean,
      default: false,
    },
    editMode: {
      type: Boolean,
      default: true,
    },
    agentMode: {
      type: Number,
      default: 0,
    },
    modalMode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isCompanyIndividual() {
      if (this.companyData) {
        let strCompany = new String(this.companyData.inn);
        if (strCompany.trim().length == 12) return true;
      }
      return false;
    },

    isPublicHashSave() {
      if (this.publicHash) {
        if (this.bidStatus == 0) return true;
        if (this.bidStatus == 30) return true;
        return false;
      }
      return true;
    },
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.saveCompany();
      } else {
        this.$root.$emit("onNextCompany");
      }
    },
    resetValidation() {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    async getCompanyByInnOgrn() {
      this.isGetCompanyByInnOgrn = true;
      await apiCallTrue({
        url: `v1/autocomplete/organization/${this.innOgrn}`,
      })
        .then((response) => {
          this.fillCompanyData(response.data.data.data);
          this.isGetCompanyByInnOgrn = false;
        })
        .catch((error) => {
          this.getCompanyByInnOgrnMessage = error.message;
          this.isGetCompanyByInnOgrn = false;
        });
    },
    async saveCompany() {
      this.errors = null;
      this.errorsText = null;
      // const id = this.companyData.user_id;
      const companyId = this.companyData.id;

      if (this.setPostAddressAsLegal) {
        this.fillPostAddress();
      }
      const url = this.agentMode
        ? `v1/company/public-hash/${this.publicHash}`
        : `v1/company/${companyId}`;
      const data = this.companyData;

      await apiCallTrue({
        method: "POST",
        url,
        data,
      })
        .then((response) => {
          console.log(response.data.data.result, "save resp");
          this.errors = null;
          this.isUpdated = true;

          showNotify("company-updated");

          if (!companyId) {
            setTimeout(() => this.$emit("nextTab"), 2000);
          }
          setTimeout(() => (this.isUpdated = false), 2001);

          this.$root.$emit("onNextCompany", true);
        })
        .catch((error) => {
          console.log(error, "save resp");

          if (error.validation) {
            this.errors = error.validation;
            this.errorMessages = error.validation;
          } else {
            this.errorsText = error.message;
          }
          this.$root.$emit("onNextCompany");
        });
    },
    fillCompanyData(data) {
      this.companyData.organization_full_name = data.name.full_with_opf;
      this.companyData.organization_short_name = data.name.short_with_opf;
      this.companyData.inn = data.inn;

      switch (data.opf.code) {
        case "50102":
          this.companyData.organization_type = 1;
          break;
        case "12247":
        case "12267":
          this.companyData.organization_type = 2;
          break;
        default:
          this.companyData.organization_type = 3;
      }
      this.companyData.kpp = data.kpp;
      this.companyData.ogrn = data.ogrn;
      this.companyData.okved = data.okved;
      this.companyData.okpo = data.okpo;
      if (data.management) {
        this.companyData.contact_person_full_name = data.management.name || "";
      }
      this.companyData.legal_city = data.address.data.city;
      this.companyData.legal_street = data.address.data.street_with_type;
      this.companyData.legal_house = data.address.data.house;
      this.companyData.legal_office = data.address.data.flat;
      this.companyData.legal_zipcode = data.address.data.postal_code;

      this.companyData.organization_created_date = new Date(
        data.state.registration_date
      )
        .toISOString()
        .substr(0, 10);
      this.deFormatOrganizationCreatedDate();

      this.companyData.reg_organization_name =
        data.authorities.fts_registration.name;
      this.companyData.reg_place = data.authorities.fts_registration.address;

      this.companyData.reg_certificate_number = `${data.documents.fts_registration.series} ${data.documents.fts_registration.number}`;
      this.$refs.form.validate();
    },
    saveOrganizationCreatedDate(date) {
      this.$refs.organization_created_date.save(date);
      this.deFormatOrganizationCreatedDate();
    },
    formatOrganizationCreatedDate() {
      if (this.organization_created_date) {
        this.companyData.organization_created_date = this.organization_created_date
          .split(".")
          .reverse()
          .join("-");
      }
    },
    deFormatOrganizationCreatedDate() {
      if (this.companyData.organization_created_date) {
        this.organization_created_date = this.companyData.organization_created_date
          .split("-")
          .reverse()
          .join(".");
      }
    },
    fillPostAddress() {
      this.companyData.postal_city = this.companyData.legal_city;
      this.companyData.postal_street = this.companyData.legal_street;
      this.companyData.postal_house = this.companyData.legal_house;
      this.companyData.postal_office = this.companyData.legal_office;
      this.companyData.postal_zipcode = this.companyData.legal_zipcode;
    },
    getOkveds() {
      axios.defaults.headers.common = {
        Authorization: "Token 89b29b1c40ba409aa15e8671be806a1d2e44fb63",
      };
      axios
        .post(
          "https://suggestions.dadata.ru/suggestions/api/4_1/rs/findById/okved2",
          { query: this.search },
          {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
            },
          }
        )
        .then((response) => {
          this.okveds = response.data.suggestions.map((item) => item.data);
        })
        .catch((error) => (this.errors = error));
    },
    setDefaults() {
      if (!this.companyData.legal_form) {
        this.companyData.legal_form = 1;
      }
      if (!this.companyData.organization_purpose) {
        this.companyData.organization_purpose = 1;
      }
    },
  },
  components: {
    tips,
  },
  mounted() {
    this.resetValidation();
    this.deFormatOrganizationCreatedDate();
    this.setDefaults();
  },
  watch: {
    organizationCreatedDate(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    setPostAddressAsLegal(val) {
      val && this.fillPostAddress();
    },
  },
};
</script>

<style lang="scss">
.divider {
  height: 36px;
  background: #fafafa;
  margin-left: -28px;
  width: calc(100% + 56px);
  box-shadow: inset 0 0 10px #eee;
}
.address-toggle {
  .v-label {
    color: #fb8c00 !important;
  }
}
</style>
